import { getGlAccountLedger } from "@/services/gl.service";
import { useQuery } from "@tanstack/react-query";

export const useGlAccountLedger = (
  glId,
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  return useQuery({
    queryKey: [
      "gl-account-ledger",
      glId,
      params.page,
      params.size,
      params.search,
      params.fromDate,
      params.toDate,
      params.direction,
    ],
    queryFn: () => getGlAccountLedger(glId, params),
    enabled: enabled && !!glId,
    ...options,
  });
};